import { Reducer } from 'redux';
import { AuthTypes, AuthState } from './types';
import { api } from '../../../services/api';

const INITIAL_STATE: AuthState = {
  token: '',
  isLoggedIn: false,
};

const reducer: Reducer<AuthState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthTypes.LOGIN_SUCCESS: {
      const newState = { ...state };

      newState.isLoggedIn = true;
      newState.token = action.payload;
      return newState;
    }

    case AuthTypes.LOGIN_FAILURE: {
      delete api.defaults.headers.Authorization;
      const newState = { ...INITIAL_STATE };
      return newState;
    }

    default:
      return state;
  }
};

export default reducer;
